import React, { useState } from 'react';
import { ImageIcon } from 'lucide-react';
/**
 * Renders a photo from a direct public image URL. If the URL is missing or
 * fails to load, an on-brand fallback panel is shown instead of a blank box.
 * Image sources live in data/clearAlignerMedia.ts — swap a `src` there to
 * replace a photo; the layout stays identical.
 */
interface MediaPlaceholderProps {
  src?: string;
  alt: string;
  /** Short description of the photo, shown only in the fallback state. */
  caption: string;
  className?: string;
}
export function MediaPlaceholder({
  src,
  alt,
  caption,
  className = ''
}: MediaPlaceholderProps) {
  const [failed, setFailed] = useState(false);
  if (src && !failed) {
    return <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} className={`w-full h-full object-cover ${className}`} data-id="element-505" data-mp="urmxek3bafyt" />;
  }
  return <div role="img" aria-label={alt} className={`w-full h-full bg-[#EFE8DE] border border-beige/70 flex flex-col items-center justify-center text-center px-6 py-8 ${className}`} data-id="element-506" data-mp="264pdzf5ev5iz">
      <span className="w-11 h-11 rounded-full bg-ivory border border-beige/80 flex items-center justify-center mb-3" data-id="element-507" data-mp="dapapoysxn4q">
        <ImageIcon className="w-5 h-5 text-forest-600" aria-hidden="true" data-id="element-508" data-mp="96hj9k0ylt2t" />
      </span>
      <span className="text-sm font-medium text-forest-700" data-id="element-509" data-mp="4866p1ja54gw">{caption}</span>
    </div>;
}